import { createProgression as baseCreateProgression } from '@app/state/progression/progression'
import { createToast } from "@/modules/toast-message"

/**
 * Initialises the progression for the form
 * 
 * @returns {Object}
 */
export function createProgression(){
    return baseCreateProgression()
}

/**
 * Applies a callback to the progression get API to set the progress on the form
 * 
 * @param {Object}      progression 
 * @param {Object}      form 
 * @param {Ref<String>} section
 * @param {Object}      data
 */
export function applyProgressionApiCallback(progression, form, section, { user }){
    progression.actions.get.api.callbacks.add(
        'onSuccess',
        async (data) => {
            data.data = {
                ...data.data,
                ...data.data._position
            }

            if(user.loading.value){
                await user.api.execute()
            }

            const success = await form.setProgress(data)
    
            if(success){
                section.value = data.data.section ?? 'form'
            }
    
            createToast("Your progress has been loaded", "info")
        }
    )

    progression.actions.delete.api.callbacks.add(
        'onSuccess',
        async (data) => {
            location.reload()
        }
    )
}